/**
 * Something standing in the road, and somebody due along it.
 *
 * A beat posts one (`chapters.js`, `posts`). What posting it does is the whole
 * of what is authored: one group of animals is put out on the road, and the
 * clock starts on whoever is coming along it. Nothing after that is written.
 * The animals do what their row in `wildlife.js` says, which for a burro is to
 * stand where it is and go where food goes, and whether the road is clear when
 * the shuttle comes is whether you cleared it.
 *
 *   animal    which wildlife row is put out, and where, in feet
 *   road      the rooms that are the road: an animal in one of them is in
 *             the way
 *   due       game minutes after it is posted that the shuttle comes through
 *   award     standing when the road is clear, early or on the minute
 *   blocked   standing when they are still on it when the shuttle comes
 *   hurt      standing when one of them was hurt getting them off it: run
 *             into by a cart, or hit by something thrown. The job was to move
 *             them, and a burro is a protected animal in the county it lives in
 *   says      what the screen says, and what the journal says, for each
 */
export const BLOCKADES = [
  {
    id: 'burros-on-the-road',
    title: 'Burros on the cart road',
    animal: { id: 'burro', at: [-165, 40] },
    road: ['road-1', 'road-2', 'road-3', 'gate'],
    due: 60,
    award: { valet: 10 },
    blocked: { valet: -6 },
    hurt: { valet: -10, management: -4 },
    says: {
      clear: ['The shuttle came through. Nothing in the road.', 'The road was clear for the shuttle'],
      blocked: ['The shuttle got as far as the burros and turned back.', 'The shuttle turned back at the burros'],
      hurt: ['That was a burro. Somebody will have seen it.', 'A burro was hurt on the road'],
    },
  },
];

export const BLOCKADES_BY_ID = Object.freeze(Object.fromEntries(BLOCKADES.map((row) => [row.id, row])));

export default BLOCKADES;
